<script setup lang="ts">
    import { ICreateWidget, IWidget } from '@/js/services/api/widget/types';
    import { isWidget } from '@/js/utils/widgetUtils';
    import ParsedMarkdown from '../ParsedMarkdown.vue';
    import { computed } from 'vue';

    interface Props {
        widget: IWidget<'Text'> | ICreateWidget<'Text'>;
    }

    const props = defineProps<Props>();

    const textContent = computed(() =>
        isWidget(props.widget) ? props.widget.textWidget.text : props.widget.text
    );
</script>
<template>
    <div class="text-widget-outer w-full min-h-full flex items-start justify-center py-3">
        <div class="text-widget-content max-w-4/5">
            <ParsedMarkdown v-if="textContent" :markdown="textContent" :breaks="true" />
        </div>
    </div>
</template>
